export default {
  CLEVER: "clever",
  GOOGLE: "google",
};
